import React, { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import VariationsIcon from '@mui/icons-material/ViewCarousel';

import Skeleton from '@material-ui/lab/Skeleton';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment'; // Importe a biblioteca Moment.js
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {
    Box,
    Tooltip
} from '@mui/material';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import {
    MaterialReactTable,

} from 'material-react-table';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import Link from '@mui/material/Link';
import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

import AdicionarEstoque from './adicionarEstoque.js';

function novo() {
    window.location.href = "/gestao/operacional/almoxarifado/estoque/cadastrarentrada"

}

export default function Estoque() {

    const [objetos, setObjetos] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [globalFilter, setGlobalFilter] = useState('');
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50,
    });
    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    // Dark mode state and theme config
    const [darkMode, setDarkMode] = useState(Cookies.get('darkMode') === 'true');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDarkMode(Cookies.get('darkMode') === 'true');
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    type: darkMode ? 'dark' : 'light',
                    primary: {
                        main: '#3f51b5',
                    },
                    secondary: {
                        main: '#f50057',
                    },
                    background: {
                        default: darkMode ? '#121212' : '#ffffff',
                        paper: darkMode ? '#1e1e1e' : '#ffffff',
                    },
                    text: {
                        primary: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                        secondary: darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)',
                    },
                },
                overrides: {
                    MuiTextField: {
                        root: {
                            '& .MuiInputBase-input': {
                                color: darkMode ? '#ffffff' : 'inherit',
                            },
                        },
                    },
                    MuiTypography: {
                        root: {
                            color: darkMode ? '#ffffff !important' : 'inherit',
                        },
                    },
                    MuiOutlinedInput: {
                        root: {
                            '& $notchedOutline': {
                                borderColor: darkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover $notchedOutline': {
                                borderColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    },
                    MuiInput: {
                        underline: {
                            '&:before': {
                                borderBottomColor: darkMode ? 'rgba(255, 255, 255, 0.42)' : 'rgba(0, 0, 0, 0.42)',
                            },
                            '&:hover:not($disabled):before': {
                                borderBottomColor: darkMode ? '#ffffff' : 'rgba(0, 0, 0, 0.87)',
                            },
                        },
                    },
                    MuiInputLabel: {
                        root: {
                            color: darkMode ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)',
                        },
                    },
                },
            }),
        [darkMode],
    );

    const [loading, setLoading] = useState(true);

    async function listar() {
        if (!objetos.length) {
            setLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const response = await api.get("v1/protected/almoxarifado/estoque/listartodospaginado", {
                headers,
                params: {
                    busca: globalFilter || '',
                    size: pagination.pageSize,
                    page: pagination.pageIndex,
                }
            });

            setObjetos(response.data.dados || []);
            setRowCount(response.data.total || 0);
            setLoading(false);
            setIsRefetching(false);
            setIsError(false);

        } catch (_err) {
            console.log("Erro ao listar objetos: " + _err);
            setLoading(false);
            setIsRefetching(false);
            setIsError(true);
        }
    }

    useEffect(() => {
        listar();
    }, [pagination.pageIndex, pagination.pageSize, globalFilter]);




    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    function returnDescricaoCotacao(cotacao) {

        var texto =
            "Insumo: " +
            cotacao.insumo.nome +
            "\nMarca/Modelo: " + cotacao.insumo.marca + "/" + cotacao.insumo.modelo +
            "\nCódigo Fornecedor: " + cotacao.insumo.codigo_fornecedor +
            "\nDescrição: " + cotacao.insumo.descricao +
            "\nUnidade: " +
            cotacao.unidade +
            "\nData Cotação: " +
            cotacao.data;
        return texto;
    }

    function returnDescricaoStatus(status_item) {
        var texto = "";

        if (status_item === 0) {
            texto = "DISPONÍVEL";
        }
        else if (status_item === 1) {
            texto = "RESERVADO";
        }
        else if (status_item === 2) {
            texto = "RETIRADO";
        }
        else if (status_item === 3) {
            texto = "FALHA";
        }

        return texto
    }

    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }

    function returnDescricaoOrdemCompra(ordem) {
        // var texto = "Ordem_ID: " + ordem.id_ordem_compra + "\nFornecedor: " + returnDescricaoFornecedor(ordem.fornecedor) + "\nDescrição da Ordem: " + ordem.descricao + "\nData prevista de entrega: " + ordem.data_prevista_entrega;
        //  return texto;
        return '';
    }


    function returnDescricaoEntradaEstoque(entrada_estoque) {
        var texto = "Entrada_Estoque_ID: " + entrada_estoque.id_entrada_estoque;
        return texto;
    }


    const handleClickEdicao = (event, cellValues) => {
        window.open("/gestao/operacional/almoxarifado/estoque/gerenciaritemestoque/" + cellValues.row.id_item_estoque, '_blank');
    };


    function returnDescricaoArmazenamento(armazenamento) {
        if (armazenamento) {
            var texto = "ID_Armazenamento: " + armazenamento.id_armazenamento + "\nSala " + armazenamento.sala
                + "\nCorredor " + armazenamento.corredor
                + "\nBloco " + armazenamento.bloco
                + "\nGondôla " + armazenamento.gondola
                + "\nPrateleira " + armazenamento.prateleira;
            return texto;
        } else {
            return "";
        }
    }





    function returnDescricaoArmazenamento(armazenamento) {
        try {
            if (!armazenamento) {
                return "Informações de armazenamento não disponíveis.";
            }

            const texto =
                "Descrição: " + (armazenamento.descricao || "N/A") + "\n" +
                "Sala: " + (armazenamento.sala || "N/A") + "\n" +
                "Corredor: " + (armazenamento.corredor || "N/A") + "\n" +
                "Bloco: " + (armazenamento.bloco || "N/A") + "\n" +
                "Gôndola: " + (armazenamento.gondola || "N/A") + "\n" +
                "Prateleira: " + (armazenamento.prateleira || "N/A");

            return texto;
        } catch (error) {
            console.error("Erro ao montar descrição do armazenamento:", error);
            return "Erro ao obter dados de armazenamento.";
        }
    }


    /* {
               header: 'Fornecedor',
               size: 30,
               accessorKey: 'item.cotacao.fornecedor',
               Cell: ({ renderedCellValue }) => {
    
                   var tipo_fornecedor = renderedCellValue.tipo_fornecedor;
                   return (
                       <Typography component="h1" style={{ fontSize: 12 }} variant="h6" color="inherit" noWrap>
                           {tipo_fornecedor === 0 ? (renderedCellValue.nome + " " + renderedCellValue.sobrenome) : renderedCellValue.nome_fantasia}
                       </Typography>
                   )
               }
           },
           {
               header: 'Ordem de Compra',
               size: 30,
               accessorKey: 'ordem_compra',
               Cell: ({ renderedCellValue }) => {
                   return (
                       <a href={"/gestao/administracao/ordensdecompras/editar/" + renderedCellValue.id_ordem_compra} target="_blank">{"OC" + renderedCellValue.id_ordem_compra}</a>
                   )
               }
           },
          
           {
               header: 'Valor Unitário',
               size: 30,
               Cell: ({ row }) => {
                   return (
                       <span>
                           {currencyFormatter.format(row.original.item.cotacao.valor_unitario + row.original.item.cotacao.valor_ipi + row.original.item.cotacao.valor_icms)}
                       </span>
                   )
               }
           },
          
           {
               header: 'Entrada',
               size: 30,
               accessorKey: 'entrada_estoque',
               Cell: ({ renderedCellValue }) => {
                   return (
                       <a href={"/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/" + renderedCellValue.id_entrada_estoque} target="_blank">{"OEE" + renderedCellValue.id_entrada_estoque + " em " + moment(renderedCellValue.data_criacao).format('DD/MM/YYYY')}</a>
                   )
               }
           },
           */

    const formatarMoeda = (valor) =>
        Number(valor || 0).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

    const columnsItensEstoque = useMemo(
        () => [

            {
                accessorKey: 'id_item_estoque', //normal accessorKey
                header: 'ID',
                size: 30,
                maxWidth: 30,
                id: 'id_item_estoque',
            },

            {
                header: 'Status',
                size: 30,
                accessorKey: 'status_item',
                Cell: ({ renderedCellValue }) => {

                    return (
                        <span>{returnDescricaoStatus(renderedCellValue)}</span>
                    );
                }
            },

            {
                header: 'Código Barras',
                size: 30,
                accessorKey: 'codigo_barras',
                Cell: ({ renderedCellValue }) => {

                    return (
                        <span>{renderedCellValue}</span>
                    );
                }
            },
            {
                header: 'Armazenamento',
                size: 300,
                accessorKey: 'descricao_armazenamento',
                Cell: ({ renderedCellValue }) => (
                    <span style={{ minWidth: '300px' }}>{renderedCellValue}</span>
                ),
                Footer: ({ table }) => {
                    const rows = table.getPrePaginationRowModel().rows;

                    const totalEntrada = rows.reduce(
                        (acc, row) => acc + Number(row.original.valor_unitario || 0),
                        0
                    );

                    const totalSaida = rows.reduce(
                        (acc, row) =>
                            row.original.id_saida_estoque > 0
                                ? acc + Number(row.original.valor_unitario || 0)
                                : acc,
                        0
                    );

                    const totalEstoque = rows.reduce(
                        (acc, row) =>
                            row.original.id_saida_estoque === 0
                                ? acc + Number(row.original.valor_unitario || 0)
                                : acc,
                        0
                    );

                    return (
                        <Box
                            sx={{
                                fontSize: 18,               // 🔹 letra grande
                                fontWeight: 'bold',
                                lineHeight: 1.8,
                                textAlign: 'left',
                                p: 2,
                                backgroundColor: darkMode ? '#1e1e1e' : '#f3f4f6',
                                borderTop: darkMode ? '2px solid #555' : '2px solid #d1d5db',
                                color: theme.palette.text.primary,
                            }}
                        >
                            <div>📥 Valor Total Entrada: {formatarMoeda(totalEntrada)}</div>
                            <div>🚚 Valor Total Saída: {formatarMoeda(totalSaida)}</div>
                            <div>📦 Valor Total em Estoque: {formatarMoeda(totalEstoque)}</div>
                        </Box>
                    );
                },
            },
            {
                header: 'Informações Extras',
                size: 30,
                Cell: ({ row }) => {
                    const item = row.original

                    if (!item) return <span>-</span>;

                    const formatarMoeda = (valor) =>
                        Number(valor || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        });

                    return (
                        <Tooltip
                            arrow
                            placement="right"
                            title={
                                <div style={{ minWidth: 400 }}>
                                    <Box
                                        sx={{
                                            p: 2,
                                            backgroundColor: darkMode ? '#2d2d2d' : '#ffffff',
                                            color: darkMode ? '#ffffff' : '#1f2937',
                                            borderRadius: 2,
                                            boxShadow: 3,
                                            fontSize: 18,
                                        }}
                                    >
                                        {/* ENTRADA DE ESTOQUE */}
                                        {item.id_entrada_estoque && (
                                            <Box mb={1}>
                                                📥{' '}
                                                <Link
                                                    href={`/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/${item.id_entrada_estoque}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    underline="hover"
                                                    sx={{ color: darkMode ? '#90caf9' : 'inherit' }}
                                                >
                                                    Entrada de Estoque nº {item.id_entrada_estoque} 🔗
                                                </Link>
                                            </Box>
                                        )}

                                        {/* ORDEM DE COMPRA */}
                                        {item.id_ordem_compra && (
                                            <Box mb={1}>
                                                🧾{' '}
                                                <Link
                                                    href={`/gestao/administracao/ordensdecompras/editar/${item.id_ordem_compra}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    underline="hover"
                                                    sx={{ color: darkMode ? '#90caf9' : 'inherit' }}
                                                >
                                                    Ordem de Compra nº {item.id_ordem_compra} 🔗
                                                </Link>
                                            </Box>
                                        )}

                                        {/* ORDEM DE COMPRA RESERVADA */}
                                        {item.id_ordem_compra_reservado && (
                                            <Box mb={1} sx={{ color: darkMode ? '#ffb74d' : '#92400e' }}>
                                                🟡{' '}
                                                <Link
                                                    href={`/gestao/administracao/ordensdecompras/editar/${item.id_ordem_compra_reservado}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    underline="hover"
                                                    sx={{ color: 'inherit' }}
                                                >
                                                    Ordem de Compra Reservada nº {item.id_ordem_compra_reservado} 🔗
                                                </Link>
                                            </Box>
                                        )}

                                        {/* ORDEM DE SERVIÇO RESERVADA */}
                                        {item.id_ordem_servico_reservada && (
                                            <Box mb={1} sx={{ color: darkMode ? '#b39ddb' : '#6d28d9' }}>
                                                🟣{' '}
                                                <Link
                                                    href={`/gestao/administracao/ordensdeservicos/editar/${item.id_ordem_servico_reservada}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    underline="hover"
                                                    sx={{ color: 'inherit' }}
                                                >
                                                    Ordem de Serviço Reservada nº {item.id_ordem_servico_reservada} 🔗
                                                </Link>
                                            </Box>
                                        )}

                                        {/* ITEM DA ORDEM DE COMPRA */}
                                        {item.id_item_ordem_compra && (
                                            <Box mb={1}>
                                                📦 Item da Ordem de Compra nº {item.id_item_ordem_compra}
                                            </Box>
                                        )}

                                        {/* VALOR */}
                                        {item.valor_unitario > 0 && (
                                            <Box mb={1}>
                                                💰 <strong>Valor:</strong> {formatarMoeda(item.valor_unitario)}
                                            </Box>
                                        )}

                                        {/* SAÍDA DE ESTOQUE */}
                                        {item.id_saida_estoque > 0 ? (
                                            <Box>
                                                🚚{' '}
                                                <Link
                                                    href={`/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/${item.id_saida_estoque}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    underline="hover"
                                                    sx={{ color: darkMode ? '#90caf9' : 'inherit' }}
                                                >
                                                    Saída de Estoque nº {item.id_saida_estoque} 🔗
                                                </Link>
                                            </Box>
                                        ) : (
                                            <Box sx={{ color: '#6b7280', fontStyle: 'italic' }}>
                                                ⛔ Item não saiu do estoque
                                            </Box>
                                        )}
                                    </Box>

                                </div>
                            }
                        >
                            <Box
                                sx={{
                                    cursor: 'pointer',
                                    color: darkMode ? '#90caf9' : '#2563eb',
                                    fontWeight: 500,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                ℹ️ Informações
                            </Box>
                        </Tooltip>

                    );
                },
            }

        ],
        [],
    );



    const columns = useMemo(
        () => [

            {
                accessorKey: 'insumo.id_insumo', //normal accessorKey
                header: 'ID Insumo',
                size: 30,
                id: 1,
            },

            {

                accessorKey: 'insumo.descricao',
                header: 'Descrição',
                size: 300,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ maxWidth: '300px', wordWrap: 'break-word', display: 'inline-block' }}>
                        {renderedCellValue}
                    </span>
                ),
                id: 2,
            },

            {
                id: 4,
                accessorKey: 'itens_estoque',
                header: 'Estoque Atual',
                size: 50,
                Cell: ({ cell }) => {
                    const itens = cell.getValue();

                    const disponiveis = Array.isArray(itens)
                        ? itens.filter(item => item.status_item === 0).length
                        : 0;

                    return (
                        <span style={{ maxWidth: '50px', wordWrap: 'break-word', display: 'inline-block' }}>
                            {disponiveis}
                        </span>
                    );
                },
            },
            {
                id: 5,
                accessorKey: 'itens_estoque',
                header: 'Entradas',
                size: 50,
                Cell: ({ cell }) => (
                    <span style={{ maxWidth: '50px', wordWrap: 'break-word', display: 'inline-block' }}>
                        {Array.isArray(cell.getValue()) ? cell.getValue().length : 0}
                    </span>
                ),
            },
            {
                id: 6,
                accessorKey: 'itens_estoque',
                header: 'Reservados',
                size: 50,
                Cell: ({ cell }) => {
                    const itens = cell.getValue();

                    const reservados = Array.isArray(itens)
                        ? itens.filter(item => item.status_item === 1).length
                        : 0;

                    return (
                        <span style={{ maxWidth: '50px', wordWrap: 'break-word', display: 'inline-block' }}>
                            {reservados}
                        </span>
                    );
                },
            },
            {
                id: 7,
                accessorKey: 'itens_estoque',
                header: 'Saídas',
                size: 50,
                Cell: ({ cell }) => {
                    const itens = cell.getValue();

                    const reservados = Array.isArray(itens)
                        ? itens.filter(item => item.status_item === 2).length
                        : 0;

                    return (
                        <span style={{ maxWidth: '50px', wordWrap: 'break-word', display: 'inline-block' }}>
                            {reservados}
                        </span>
                    );
                },
            },
            // 🆕 Coluna agregada para busca global
            {
                id: 8,
                accessorKey: "search_field",
                header: "",
                enableColumnFilter: false,
                enableSorting: false,
                size: 0,
                Cell: () => null,
                muiTableBodyCellProps: { sx: { display: 'none' } },
            }



        ],
        [],
    );



    const [insumoAdicionar, setInsumoAdicionar] = useState(null);
    const [openAdicionarEstoque, setOpenAdicionarEstoque] = useState(false);

    function handleOpenAdicionarEstoque(row) {
        setInsumoAdicionar(row.original.insumo);

        setOpenAdicionarEstoque(true);

    }

    function closeAdicionarEstoque() {
        setOpenAdicionarEstoque(false);
        setInsumoAdicionar(null);
        listar();
    }


    function handleClickEditar(row) {
        const idInsumo = row.original.insumo.id_insumo;
        const url = `/gestao/operacional/almoxarifado/insumos/editarinsumo/${idInsumo}`;
        window.open(url, '_blank');
    }

    function handleClickGerenciar(row) {
        const idInsumo = row.original.insumo.id_insumo;
        const url = `/gestao/operacional/almoxarifado/cotacoes/listar/${idInsumo}`;
        window.open(url, '_blank');
    }

    function handleClickReplicar(row) {
        const idInsumo = row.original.insumo.id_insumo;
        const url = `/gestao/operacional/almoxarifado/insumos/cadastrarinsumo/${idInsumo}/0`;
        window.open(url, '_blank');
    }


    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: theme.palette.background.default, minHeight: '100vh', color: theme.palette.text.primary }}>

                <NavegadorGestao
                    Almoxarifado={true}
                    Estoque={true}
                    corFundo={darkMode ? '#333' : 'white'} travado={true} corTexto={darkMode ? 'white' : 'black'}
                />
                <div style={{ padding: 10, width: '100%', height: '100%' }}>
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :

                        <div>
                            <div
                                style={{
                                    backgroundColor: darkMode ? '#1e1e1e' : 'white',
                                    margin: 5,
                                    height: 'calc(100vh - 30px)', // limita a altura para caber na tela
                                    overflow: 'hidden', // evita scroll na página
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                {objetos && (
                                    <MaterialReactTable
                                        columns={columns}
                                        data={objetos}
                                        enableBottomToolbar={true}
                                        enableGlobalFilterModes
                                        enablePagination={true}
                                        enableRowActions={true}
                                        manualPagination={true}
                                        onPaginationChange={setPagination}
                                        onGlobalFilterChange={setGlobalFilter}
                                        rowCount={rowCount}
                                        state={{
                                            pagination,
                                            globalFilter,
                                            isLoading: loading,
                                            showAlertBanner: isError,
                                            showProgressBars: isRefetching,
                                        }}
                                        paginationDisplayMode="pages"
                                        getRowId={(row) => row.id_insumo_estoque}
                                        enableGrouping
                                        enableExpandAll={false}
                                        enableExpanding={true}
                                        filterFromLeafRows={true}
                                        paginateExpandedRows={false}
                                        initialState={{
                                            showGlobalFilter: true,
                                            columnVisibility: { search_field: false },
                                        }}
                                        muiTableContainerProps={{
                                            sx: {
                                                flex: 1,
                                                overflowY: 'auto', // 🔹 rolagem interna
                                                maxHeight: 'calc(100vh - 200px)', // 🔹 impede que ultrapasse a tela
                                                '& thead': {
                                                    position: 'sticky', // 🔹 fixa o cabeçalho
                                                    top: 0,
                                                    backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                                                    zIndex: 2,
                                                },
                                            },
                                        }}
                                        muiPaginationProps={{
                                            rowsPerPageOptions: [50, 100, 200],
                                            variant: 'outlined',
                                        }}
                                        muiTableBodyRowProps={({ row }) => ({
                                            sx: {
                                                height: 20,
                                                backgroundColor: row.index % 2 === 0 ? (darkMode ? '#2c2c2c' : '#f9f9f9') : (darkMode ? '#1e1e1e' : '#e0e0e0'), // alternância
                                                transition: 'background-color 0.3s',
                                                '&:hover': {
                                                    backgroundColor: darkMode ? '#444' : '#d0f0ff', // hover azul claro
                                                },
                                            },
                                        })}
                                        enableFullScreenToggle={true}
                                        renderRowActions={({ row }) => (
                                            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                                                <Tooltip title="Edit">
                                                    <IconButton onClick={() => handleClickEditar(row)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Cotações">
                                                    <IconButton color="error" onClick={() => handleClickGerenciar(row)}>
                                                        <RequestQuoteIcon />
                                                    </IconButton>


                                                </Tooltip>

                                                <Tooltip title="Entrada de Estoque">
                                                    <IconButton onClick={() => handleOpenAdicionarEstoque(row)}>
                                                        <Inventory2Icon style={{ fontSize: 30, color: "#1976d2" }} />
                                                    </IconButton>
                                                </Tooltip>

                                            </Box>
                                        )}

                                        renderDetailPanel={({ row }) => (
                                            <Box
                                                sx={{
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                    justifyContent: 'space-around',
                                                    left: '1px',
                                                    maxWidth: '3000px',
                                                    width: '100%',
                                                }}
                                            >
                                                <MaterialReactTable
                                                    columns={columnsItensEstoque}
                                                    data={row.original.itens_estoque}
                                                    enableBottomToolbar={false}
                                                    enableTopToolbar={false}
                                                    enablePagination={true}
                                                    enableRowActions={true}
                                                    paginationDisplayMode="pages"
                                                    getRowId={(row) => row.id_item_estoque}
                                                    initialState={{
                                                        pagination: { pageSize: 1000, pageIndex: 0 },
                                                        showGlobalFilter: true,
                                                    }}
                                                    muiTableContainerProps={{
                                                        sx: {
                                                            maxHeight: '500px', // 🔹 limita a tabela expandida
                                                            overflowY: 'auto',
                                                            '& thead': {
                                                                position: 'sticky',
                                                                top: 0,
                                                                backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                                                                zIndex: 2,
                                                            },
                                                        },
                                                    }}

                                                    muiTableBodyRowProps={({ row }) => ({
                                                        sx: {
                                                            height: 20,
                                                            backgroundColor: row.index % 2 === 0 ? (darkMode ? '#2c2c2c' : '#f9f9f9') : (darkMode ? '#1e1e1e' : '#e0e0e0'), // alternância
                                                            transition: 'background-color 0.3s',
                                                            '&:hover': {
                                                                backgroundColor: darkMode ? '#444' : '#d0f0ff', // hover azul claro
                                                            },
                                                        },
                                                    })}

                                                    muiPaginationProps={{
                                                        rowsPerPageOptions: [1000, 2000, 3000],
                                                        variant: 'outlined',
                                                    }}
                                                    enableFullScreenToggle={false}
                                                />
                                            </Box>
                                        )}

                                    />
                                )}
                            </div>
                        </div>
                    }



                </div>


                <Dialog
                    open={openAdicionarEstoque}
                    onClose={() => closeAdicionarEstoque(false)}
                    aria-labelledby="autorize-dialog"
                >
                    <AdicionarEstoque insumo={insumoAdicionar} closeAdicionarEstoque={closeAdicionarEstoque} />

                </Dialog>

            </div>
        </ThemeProvider>
    );
}



